import { Stack, Typography } from 'styles';
import { HISTORY_ACTORS, HISTORY_TYPES, IHistoryItem } from 'types/History';
import { useTranslation } from 'utils/translations';
import { getFullDate } from 'utils/utils';

type Props = {
	item: IHistoryItem;
};

const HistoryItemActor = ({ item }: Props) => {
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: 'clientLabels',
	});
	const { t: tDbLabels } = useTranslation('', {
		keyPrefix: 'dbLabels',
	});

	const hasActor =
		(item.createdBy?.memberFirstName && item.createdBy?.memberLastName) ||
		item.createdBy?.memberRoleLabel;
	const hasBillingActor =
		item.typeHistory === HISTORY_TYPES.BILLING && item.createdBy?.memberRoleLabel;

	const getHistoryItemActor = () => {
		if (
			item.createdBy?.memberRole !== HISTORY_ACTORS.PROVIDER &&
			item.createdBy?.memberRole !== HISTORY_ACTORS.ADMIN &&
			item.createdBy?.memberRoleLabel
		) {
			return tDbLabels(item.createdBy.memberRoleLabel);
		}

		if (!item.createdBy?.memberFirstName || !item.createdBy?.memberLastName) {
			return null;
		}

		const userName = `${item.createdBy.memberFirstName} ${item.createdBy.memberLastName}`;

		return tClientLabels('claim.history.userInfo', {
			type: tDbLabels(item.createdBy.memberRoleLabel),
			user: userName,
		});
	};

	if (!item.createdBy) {
		return null;
	}

	return (
		<Stack flexDirection={'row'} gap={'12px'}>
			{(hasBillingActor || hasActor) && (
				<Typography variant="value3" color={'grey1.main'}>
					{getHistoryItemActor()}
				</Typography>
			)}
			<Typography variant="value3" color={'grey1.main'}>
				{getFullDate(item.lastInsert)}
			</Typography>
		</Stack>
	);
};

export default HistoryItemActor;
